import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ScoreboardService } from '../services/scoreboard.service';

@Injectable()
export class ExpiredGuard implements CanActivate {

  constructor(private scoreBoardService : ScoreboardService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return this.scoreBoardService
        .validateScoreboardTopic(route.params['id']).then((valid)=>{
          if(valid){
            return true;
          }
          this.router.navigate(['/users']);
          return false;
      }, ()=>{
          this.router.navigate(['/users']);
          return false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/expired.guard.ts